import React from "react";

import { getPublicComponentCopy } from "@/lib/publicComponentCopy";

const filterKeys = ["all", "beginner", "intermediate", "advanced", "license", "safety", "navigation", "weather", "regulations"];

export default function LearningTopicFilters({ activeFilter, onChange, lang = "en" }) {
  const labels = getPublicComponentCopy(lang).learning.filters;
  return (
    <div className="mt-5 overflow-x-auto pb-2">
      <div className="flex min-w-max gap-2">
        {filterKeys.map((value) => (
          <button
            key={value}
            type="button"
            onClick={() => onChange(value)}
            className={`rounded-full border px-4 py-2 text-sm font-black transition ${activeFilter === value ? "border-[#17A6A4] bg-[#17A6A4] text-white" : "border-[#BFDADC] bg-white/86 text-[#10233E] hover:border-[#17A6A4] hover:text-[#168F92]"}`}
          >
            {labels[value] || value}
          </button>
        ))}
      </div>
    </div>
  );
}